
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { AdUserModel } from 'models/generated/Identity.Api.Models.AdUser';


const _identity_AdControllerHelper = new Map<string, Object>();
_identity_AdControllerHelper.set('GetAdUsers', AdUserModel);


export const identity_AdControllerHelper = _identity_AdControllerHelper;

